import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { SimpleFilter } from 'components/PortalStructure';
import { IResultFilter } from 'models/search/resultfilter';
import { IRefinementGroup } from 'models/filtering/refinement';
import { SideDrawer } from 'components';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');

interface IProps {
	simpleFilterProps?: IResultFilter;
	complexFilter?: any;
	sortComponent?: any;
	refinementSelections?: IRefinementGroup[];
	onRemoveSelectedFilter?: (groupId: number, refinementId: number) => void;
	onResetFiltersClick?: () => void;
	pricesRefinementGroup?: IRefinementGroup;
	onPriceFilterRemove?: (availablePriceMax: number) => void;
	itemsCount?: number;

	/* func props */
	t?: (key: string, object?: any) => string;
	filterDrawerOpen?: boolean;
}

interface IState {
	showFilters: boolean;
}
@connect(
	(state: IStore) => ({
		filterDrawerOpen: state.shopSearchResults.filterDrawerOpen,
	}),
	() => ({}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ResultsWrapper extends React.Component<IProps, IState> {
	public static defaultProps: Partial<IProps> = {
		sortComponent: null,
	};

	private filtersRef;
	private wrapperRef;

	constructor(props) {
		super(props);

		this.state = {
			showFilters: false,
		};

		this.toggleShowFilters = this.toggleShowFilters.bind(this);
		this.filtersRef = React.createRef<HTMLElement>();
		this.wrapperRef = React.createRef<HTMLDivElement>();
	}

	public componentDidMount() {
		this.calculatePosition();
		window.addEventListener('resize', this.calculatePosition);
		document.addEventListener('scroll', this.calculatePosition);
	}

	public componentWillUnmount() {
		window.removeEventListener('resize', this.calculatePosition);
		document.removeEventListener('scroll', this.calculatePosition);
	}

	private calculatePosition = () => {
		const wrapper = this.wrapperRef.current;
		const filters = this.filtersRef.current;
		if (!filters || !wrapper) {
			return;
		}
		const header = document.getElementById('portalSubNav');
		let contentWindow: Element = document.getElementById('portalNavHolder');
		if (contentWindow) {
			contentWindow = contentWindow.nextElementSibling;
		}
		const limits = [0, window.innerHeight];
		if (contentWindow) {
			limits[1] = Math.min(contentWindow.getBoundingClientRect().bottom, limits[1]);
		}
		if (header) {
			limits[0] = Math.max(0, header.getBoundingClientRect().bottom);
		}
		if (wrapper.getBoundingClientRect().top < limits[0]) {
			filters.style.position = 'fixed';
			filters.style.top = limits[0] + 'px';
			filters.style.height = limits[1] - limits[0] + 'px';
		} else {
			filters.style.position = 'absolute';
			filters.style.top = '0px';
			filters.style.height = limits[1] - wrapper.getBoundingClientRect().top + 'px';
		}
	};

	private toggleShowFilters() {
		this.setState((s: IState) => ({ showFilters: !s.showFilters }));
	}

	public render() {
		const { simpleFilterProps, complexFilter, children } = this.props;

		// show filter if filter properties are provided
		let filterContents = null;
		if (simpleFilterProps && simpleFilterProps.items) {
			filterContents = <SimpleFilter {...simpleFilterProps} />;
		} else if (complexFilter) {
			filterContents = complexFilter;
		}

		return (
			<div className="resultsWrapper" ref={this.wrapperRef}>
				<div className="rightContent contentCards">{children}</div>
				<SideDrawer
					open={this.props.filterDrawerOpen ? this.props.filterDrawerOpen : this.state.showFilters}
					toggle={(showFilters: boolean) => this.setState({ showFilters })}
				>
					{filterContents}
				</SideDrawer>
			</div>
		);
	}
}
export { ResultsWrapper };
